import { render, staticRenderFns } from "./EditOrderStatusForm.vue?vue&type=template&id=2f9c1c04&"
import script from "./EditOrderStatusForm.vue?vue&type=script&lang=js&"
export * from "./EditOrderStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderStatusForm.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports